import Action, {POST} from "../common/Action";

export const getCustomersAction = new Action('GET_CUSTOMERS', POST, 'customers/list');

export const getCustomers = (query) => getCustomersAction.callApi(query);